import { getObjectEntries, isObjectEmpty } from "@omnia/shared/utils/objects"
import { ActionPayload, State, updateUsers } from "../state"
import { Cropping, CroppingPermissions } from "../types"
import { validateUser } from "../users"

export const croppingStateReducers = {
    setCroppingGrouping,
    setCroppingPermission
}

function setCroppingGrouping(state: State, payload: ActionPayload<"setCroppingGrouping">) {
    return {
        ...state,
        cropping: {
            ...state.cropping,
            grouping: payload
        }
    }
}

function setCroppingPermission(state: State, { userId, cropping, authorized }: ActionPayload<"setCroppingPermission">) {

    return updateUsers(state, u => {

        if (u.userId !== userId) {
            return u
        }

        const croppingPermissions = {...(u.croppingPermissions ?? {})}

        for (const croppingId of cropping) {
            croppingPermissions[croppingId] = { croppingId, authorized }
        }

        return validateUser({
            ...u,
            croppingPermissions
        })

    })
}

export function compareCroppingPermissions(a: CroppingPermissions, b: CroppingPermissions) {

    const keys = Object.keys(a).map(k => Number(k))

    return keys.every(k => {
        const ca = a[k]
        const cb = b[k]
        return ca.authorized === (cb?.authorized ?? true)
    })
}

export function getCroppingForUpdatedUser(croppingPermissions: CroppingPermissions, cropping: Cropping[]) {

    if (isObjectEmpty(croppingPermissions)) {
        return undefined
    }

    return cropping.map(c => ({
        croppingId: c.croppingId,
        authorized: croppingPermissions[c.croppingId]?.authorized ?? true
    }))

}

